export interface EmbedPublicData {
  slug: string;
  scan_id: string;
  visibility: 'public' | 'unlisted' | 'password';
  requires_password: boolean;
  expired: boolean;
  language: 'nl' | 'en' | 'de';
  branding?: { logo_url?: string; primary_color?: string };
  show_ai_modes: boolean;
  assets: {
    sog_url?: string;
    collision_url?: string;
    plan_url?: string;
    thumbnail_url?: string;
    has_staging: boolean;
    has_defurnish: boolean;
  };
}

const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? 'http://localhost:8787';

export async function resolveEmbed(slug: string): Promise<EmbedPublicData | null> {
  // Publieke embed-API — geen credentials/cookies nodig.
  // (embed-public worker stuurt geen allow-credentials, dus 'include' wordt geblokkeerd.)
  const res = await fetch(`${apiBase}/v1/embed/${slug}`, { credentials: 'omit' });
  if (!res.ok) return null;
  return (await res.json()) as EmbedPublicData;
}
